function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Icons Raw/ic_laser_idcard");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Icons-Raw/ic_laser_idcard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.99996016,12 L60.0000398,12 C61.6568721,12 63,13.3431279 63,14.9999602 L63,48.0757371 C63,49.7325693 61.6568721,51.0756972 60.0000398,51.0756972 L3.99996016,51.0756972 C2.34312791,51.0756972 1,49.7325693 1,48.0757371 L1,14.9999602 C1,13.3431279 2.34312791,12 3.99996016,12 Z",
  id: "Mask",
  fill: "#C3E8F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,37.2191235 L62.876494,37.2191235 L62.876494,48.0756972 C62.876494,49.7325515 61.5333483,51.0756972 59.876494,51.0756972 L4,51.0756972 C2.34314575,51.0756972 1,49.7325515 1,48.0756972 L1,37.2191235 Z",
  id: "Rectangle",
  fill: "#CDEAF4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fillOpacity: 0.34,
  fill: "#000000",
  x: 20,
  y: 39,
  width: 25,
  height: 2
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "48 26 56 26 56 32 48 32"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#EB0600",
  x: 48,
  y: 26,
  width: 8,
  height: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M48,28 L56,28 L56,30 L48,30 L48,28 Z",
  id: "Combined-Shape",
  fill: "#002CAC"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  fill: "#EB0600",
  x: 48,
  y: 31,
  width: 8,
  height: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.489751,33.1498568 L10.9578486,33.1498568 C10.2763399,33.1498568 9.7237998,32.6450474 9.7237998,32.0224102 L9.7237998,25.2773034 C9.7237998,24.6546662 10.2763399,24.1498568 10.9578486,24.1498568 L16.489751,24.1498568 C17.1712597,24.1498568 17.7237998,24.6546662 17.7237998,25.2773034 L17.7237998,32.0224102 C17.7237998,32.6450474 17.1712597,33.1498568 16.489751,33.1498568 Z",
  id: "Path",
  fill: "#FFCC3B",
  fillRule: "nonzero",
  transform: "translate(13.723800, 28.649857) rotate(90.000000) translate(-13.723800, -28.649857) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.5,35.5 L16.5,35.5 L16.5,44.5 L48.5,44.5 L48.5,35.5 Z",
  id: "Rectangle",
  stroke: "#EB0600"
}));

var SvgIcLaserIdcard = function SvgIcLaserIdcard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLaserIdcard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_laser_idcard.ab3d7caf.svg";
export { ForwardRef as ReactComponent };